import { render } from "./RaceResultsSlider.vue?vue&type=template&id=531d2b68&scoped=true"
import script from "./RaceResultsSlider.vue?vue&type=script&lang=js"
export * from "./RaceResultsSlider.vue?vue&type=script&lang=js"

import "./RaceResultsSlider.vue?vue&type=style&index=0&id=531d2b68&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-531d2b68"]])

export default __exports__